import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'badge'
})
export class BadgePipe implements PipeTransform {
  transform(value: number): string {

    if (!value) { return ''; }
    return value > 9
      ? '+9'
      : value.toString();
  }
}
